import { render, staticRenderFns } from "./flowform.vue?vue&type=template&id=13262356&scoped=true"
import script from "./flowform.vue?vue&type=script&lang=js"
export * from "./flowform.vue?vue&type=script&lang=js"
import style0 from "./flowform.vue?vue&type=style&index=0&id=13262356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13262356",
  null
  
)

export default component.exports